// src/Api/useUrlClassificationApi.js
import { useState } from "react";
import { post } from "./api";

const useUrlClassificationApi = () => {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const classifyUrl = async (payload) => {
    try {
      setLoading(true);

      const response = await post("classify", payload);

      
      console.log("Classify Response:================", response);

      const categories = response.categories || response.data?.categories || [];

      setResult({ categories });
    } catch (error) {
      console.error("Classify Error:", error);
      setResult({ categories: [] });
    } finally {
      setLoading(false);
    }
  };

  return { classifyUrl, result, loading };
};

export default useUrlClassificationApi;
